import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LucideAngularModule } from "lucide-angular";

@Component({
  selector: "app-scoring-rules",
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: "./scoring-rules.component.html",
  styleUrl: "./scoring-rules.component.css",
})
export class ScoringRulesComponent {
  isExpanded = false;

  pointRules = [
    {
      icon: "circle-dot",
      description: "Playing a match",
      points: "+15",
      type: "base",
    },
    {
      icon: "trophy",
      description: "Each set won",
      points: "+20",
      type: "positive",
    },
    {
      icon: "circle-x",
      description: "Each set lost",
      points: "-5",
      type: "negative",
    },
    {
      icon: "crown",
      description: "Match victory bonus",
      points: "+20",
      type: "bonus",
    },
  ];

  examples = [
    {
      scenario: "Win 2-0",
      sets: "2W / 0L",
      calculation: "15 + 40 - 0 + 20",
      total: "+75 PP",
      type: "win",
    },
    {
      scenario: "Win 2-1",
      sets: "2W / 1L",
      calculation: "15 + 40 - 5 + 20",
      total: "+70 PP",
      type: "win",
    },
    {
      scenario: "Lose 1-2",
      sets: "1W / 2L",
      calculation: "15 + 20 - 10 + 0",
      total: "+25 PP",
      type: "lose",
    },
    {
      scenario: "Lose 0-2",
      sets: "0W / 2L",
      calculation: "15 + 0 - 10 + 0",
      total: "+5 PP",
      type: "lose",
    },
  ];

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }
}
